import { useContext, useState } from "react";
import { Space } from "antd";
import { useParams } from "react-router-dom";

import {
  KCollapse,
  KCardItemInfo,
  KLgText700,
  ModalAddTopic,
} from "@components";
import { KContext } from "@context";
import { IParams } from "@types";
import { useCustomNavigate } from "@hooks";
import { AddPlusIcon } from "@assets/icons";
import { NewTopicContainer } from "@pages/card-details/styles";
import { ButtonAddStyled } from "components/CardItemInfo/styles";

export const CardAddTopic = ({
  handleAfterCreate,
}: {
  handleAfterCreate?: (topicId: string) => void;
}) => {
  const [isOpenModal, setIsOpenModal] = useState(false);

  return (
    <>
      <NewTopicContainer>
        <KLgText700>New Topic</KLgText700>
        <ButtonAddStyled
          onClick={() => {
            setIsOpenModal(true);
          }}
        >
          <AddPlusIcon />
        </ButtonAddStyled>
      </NewTopicContainer>

      <ModalAddTopic
        isOpen={isOpenModal}
        onCancel={() => {
          setIsOpenModal(false);
        }}
        handleAfterCreate={handleAfterCreate}
      />
    </>
  );
};
